module.exports = __webpack_public_path__ + "media/images/sp/specials/common/reserve_present-ff454ed9c92a987f7e47f96695248f63.svg";